// import React from "react";
import "./blogcard.css";
import trendup from "../../assets/TrendUp.png";
import Button from "../button/Button";
import { NavLink } from "react-router-dom";

// Utility function to format publish time
const formatPublishTime = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const BlogCard = ({ title, img, excert, publishTime, url }) => {
  const formattedPublishTime = formatPublishTime(publishTime);

  return (
    <div className="card hover-effect">
      {/* Image Section */}
      <div className="image-wrapper">
        <img src={img} className="card-img-top" alt="Blog Thumbnail" />
      </div>

      {/* Card Body */}
      <div className="card-body text-left">
        {/* Top Section: Badges */}
        <div
          className="d-flex justify-content-between flex-wrap align-items-center mb-3" // Adds space between items
        >
          <span className="badge text-bg-light mb-2 d-flex align-items-center">
            <img src={trendup} alt="trendup" className="mx-1" />
            Trending
          </span>
          <span className="badge text-muted text-bg-light">
            {formattedPublishTime}
          </span>
        </div>

        {/* Title */}
        <h5
          className="card-title my-3"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 1, // Limit to 1 line
            WebkitBoxOrient: "vertical",
            overflow: "hidden", // Hide overflow content
            textOverflow: "ellipsis", // Show ellipsis when content overflows
          }}
        >
          {title}
        </h5>

        {/* Excerpt */}
        <p
          className="card-text"
          dangerouslySetInnerHTML={{ __html: excert }}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 4, // Limit to 4 lines
            WebkitBoxOrient: "vertical",
            overflow: "hidden", // Hide overflow content
            textOverflow: "ellipsis", // Show ellipsis when content overflows
          }}
        ></p>

        {/* Button */}
        <NavLink
          to={`/blog/${url}`}
          style={{ textDecoration: "none" }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <Button
            className="w-50 w-sm-100 d-flex justify-content-center align-items-center fw-bold blogCardButton"
            style={{
              background: "#EEEEEE",
              color: "#000",
              fontSize: "12px",
              height: "30px",
            }}
          >
            Continue Reading&nbsp;&nbsp;&nbsp;→
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default BlogCard;
